import React, { Component } from "react";
import { withRouter } from "react-router";
import MenuItem from "./MenuItem";
import MenuItemWithChildren from "./MenuItemWithChildren";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { connect } from "react-redux";
import Banner from "../../images/Banner Lateral.png";
import { width } from "../../helpers/general";
import { sendData } from "../../helpers/auth";
import { uriList } from "../../helpers/config";
import Whatsappbtn from '../outros/whatsappbtn'
import { checarPermissao } from "../../helpers/acls";

import Nilza from "../nilza";
import "./sidebar.css";

class Sidebar extends Component {
  getIdCode = () => {
    return (
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15)
    );
  };

  // temPermissao = (_permissao) => {
  //   if (this.props?.user?.tipo == "ADMINISTRADOR" || this.props?.user?.tipo == "OPERADOR")
  //     return true

  //   const permissoes = this.props.user?.permissoes || this.props.user?.controle_acesso?.permissoes;
  //   console.log("sidebar.temPermissao(user): ", this.props.user)
  //   console.log("sidebar.temPermissao(Permissões): ", { permissoes, _permissao })
  //   if (!permissoes) return false;

  //   const _temPermissao = permissoes.some(permissao => _permissao.includes(permissao.name))
  //   console.log("sidebar.temPermissao(_temPermissao): ", _temPermissao)
  //   return _temPermissao
  // };

  getMenu = async (props) => {
    this.data = [
      {
        id: this.getIdCode(),
        url: "#",
        label: "Menu",
        visible: true,
        is_main: true,
      },
      {
        id: this.getIdCode(),
        url: "#",
        visible: props.user?.gestor || checarPermissao(props.user, "adminCadastros", ["ADMINISTRADOR", "OPERADOR"]),
        class: "waves-effect",
        label: "Cadastros",
        icon: "mdi mdi-plus-circle",
        badgeclass: "badge badge-pill badge-success float-right",
        children: [
          {
            id: this.getIdCode(),
            url: "/admin/pessoas?op=cadastrar",
            label: "Pessoas",
            visible: props.user?.gestor || checarPermissao(props.user, "adminPessoas", ["ADMINISTRADOR", "OPERADOR"]),
            icon: "mdi mdi-account-group",
          },
          {
            id: this.getIdCode(),
            url: "/admin/convenios",
            label: "Convenios",
            visible: props.user?.gestor || checarPermissao(props.user, "adminConvenios", ["ADMINISTRADOR"]) && (!props.user?.empresa_id || props.user?.empresa_id == 1),
            // visible: true,
            icon: "mdi mdi-office-building",
          },
          {
            id: this.getIdCode(),
            url: "/admin/tabelas",
            label: "Tabelas",
            visible: props.user?.gestor || checarPermissao(props.user, "adminTabelas", ["ADMINISTRADOR"]) && (!props.user?.empresa_id || props.user?.empresa_id == 1),
            icon: "mdi mdi-table-edit",
          },
          {
            id: this.getIdCode(),
            url: "/admin/coeficientes",
            label: "Coeficientes",
            visible: props.user?.gestor || checarPermissao(props.user, "adminCoeficientes", ["ADMINISTRADOR"]) && (!props.user?.empresa_id || props.user?.empresa_id == 1),
            icon: "mdi mdi-percent",
          },
          {
            id: this.getIdCode(),
            url: "/admin/emails",
            label: "Emails",
            visible: props.user?.gestor || checarPermissao(props.user, "adminEmails", ["ADMINISTRADOR"]) && (!props.user?.empresa_id || props.user?.empresa_id == 1),
            icon: "mdi mdi-email",
          },
          {
            id: this.getIdCode(),
            url: "/admin/usuarios",
            visible: props.user?.gestor || checarPermissao(props.user, "adminUsuarios", ["ADMINISTRADOR"]) && (!props.user?.empresa_id || props.user?.empresa_id == 1),
            label: "Usuários",
            icon: "mdi mdi-account-multiple",
          },
          {
            id: this.getIdCode(),
            url: "/admin/grupos_permissoes",
            visible: props.user?.gestor || checarPermissao(props.user, "adminGruposPermissoes", ["ADMINISTRADOR"]) && (!props.user?.empresa_id || props.user?.empresa_id == 1),
            label: "Permissões",
            icon: "mdi mdi-account-group",
          },
          {
            id: this.getIdCode(),
            url: "/admin/empresas",
            visible: props.user?.gestor || checarPermissao(props.user, "adminEmpresas", ["ADMINISTRADOR"]) && (!props.user?.empresa_id || props.user?.empresa_id == 1),
            label: "Empresas",
            icon: "mdi mdi-office-building",
          },
        ],
      },
      {
        id: this.getIdCode(),
        url: "/admin",
        class: "waves-effect",
        visible: checarPermissao(props.user, "adminPropostas", ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]),
        label: "Fila de Propostas",
        icon: "mdi mdi-view-dashboard",
        badgeclass: "badge badge-pill badge-success float-right",
      },
      {
        id: this.getIdCode(),
        url: "#",
        visible:
          !props.user?.tipo_credito ||
          ["CONSIGNADO", "TODOS"].indexOf(props.user?.tipo_credito) >= 0,
        class: "waves-effect",
        label: "Crédito Consignado",
        icon: "mdi mdi-cash",
        badgeclass: "badge badge-pill badge-success float-right",
        children: [
          {
            id: this.getIdCode(),
            url: "/admin/novaProposta",
            visible: checarPermissao(props.user, "adminContratoNovo", ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]),
            label: "Contrato Novo",
            icon: "mdi mdi-file-outline",
          },
          {
            id: this.getIdCode(),
            url: "/admin/Refinanciamento",
            visible: checarPermissao(props.user, "adminRefinanciamento", ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]),
            label: "Refinanciamento",
            icon: "mdi mdi-image-filter-none",
          },
          {
            id: this.getIdCode(),
            url: "/admin/Portabilidade",
            visible: checarPermissao(props.user, "adminPortabilidade", ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]),
            label: "Portabilidade",
            icon: "mdi mdi-content-save",
          },
          {
            id: this.getIdCode(),
            url: "/admin/Cartao",
            visible: checarPermissao(props.user, "adminCartao", ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]),
            label: "Cartão",
            icon: "mdi mdi-card-account-details",
          },
        ],
      },
      {
        id: this.getIdCode(),
        url: "#",
        visible:
          !props.user?.tipo_credito ||
          ["PESSOAL", "TODOS"].indexOf(props.user?.tipo_credito) >= 0,
        class: "waves-effect",
        label: "Crédito Pessoal",
        icon: "mdi mdi-account-cash",
        badgeclass: "badge badge-pill badge-success float-right",
        children: [
          {
            id: this.getIdCode(),
            url: "/admin/Fgts",
            visible: checarPermissao(props.user, "adminFgts", ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]),
            label: "Fgts",
            icon: "mdi mdi-nfc-variant",
          },
        ],
      },
      {
        id: this.getIdCode(),
        url: "#",
        visible: props.user?.tipo !== "CLIENTE",
        class: "waves-effect",
        label: "Operacional",
        icon: "mdi mdi-factory",
        badgeclass: "badge badge-pill badge-success float-right",
        children: [
          {
            id: this.getIdCode(),
            url: "/admin/calculadoraMargem",
            visible: checarPermissao(props.user, "adminCalculadoraMargem", ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]),
            label: "Calculadora Margem",
            icon: "mdi mdi-calculator",
          },
          {
            id: this.getIdCode(),
            url: "/admin/autorizacaoINSS",
            visible: checarPermissao(props.user, "adminAutorizacaoINSS", ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]),
            label: "Autorização INSS",
            icon: "mdi mdi-key",
          },
          {
            id: this.getIdCode(),
            url: "/admin/documentos",
            visible: checarPermissao(props.user, "adminDocumentos", ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]),
            label: "Documentos",
            icon: "mdi mdi-library",
          },
        ],
      },
      // {
      //   id: this.getIdCode(),
      //   url: "/admin/mensagens",
      //   visible: checarPermissao(props.user, "adminMensagens", ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]) && (!props.user?.empresa_id || props.user?.empresa_id == 1),
      //   class: "waves-effect",
      //   label: "Mensagens",
      //   icon: "mdi mdi-mail",
      //   badgeclass: "badge badge-pill badge-success float-right",
      // },
      {
        id: this.getIdCode(),
        url: "/admin/pendencias",
        visible: checarPermissao(props.user, "adminPendencias", ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]),
        class: "waves-effect",
        label: "Pendências" + (this.state.pendencias > 0 ? `(${this.state.pendencias.toString()})` : ""),
        icon: "mdi mdi-alert",
        badgeclass: "badge badge-pill badge-warning float-right",
      },
      {
        id: this.getIdCode(),
        url: "/admin/retencoes",
        visible: checarPermissao(props.user, "adminRetencoes", ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]),
        class: "waves-effect",
        label: "Retenções",
        icon: "mdi mdi-twitter-retweet",
        badgeclass: "badge badge-pill badge-warning float-right",
      },
      {
        id: this.getIdCode(),
        url: "/admin/reapresentacoes",
        visible: checarPermissao(props.user, "adminReapresentacoes", ["ADMINISTRADOR", "OPERADOR", "OPERADOR PARCEIRO"]),
        class: "waves-effect",
        label: "Reapresentacoes",
        icon: "mdi mdi-file-restore",
        badgeclass: "badge badge-pill badge-warning float-right",
      },
      {
        id: this.getIdCode(),
        url: "/admin/solicitacoes",
        visible: (checarPermissao(props.user, "adminSolicitacoes", ["ADMINISTRADOR",])) && (!props.user?.empresa_id || props.user?.empresa_id == 1),
        class: "waves-effect",
        label: "Solicitações",
        icon: "mdi mdi-alarm-light",
        badgeclass: "badge badge-pill badge-warning float-right",
      },
      {
        id: this.getIdCode(),
        url: "/admin/configuracoes",
        class: "waves-effect",
        visible: checarPermissao(props.user, "adminConfiguracoes", ["ADMINISTRADOR"]) && (!props.user?.empresa_id || props.user?.empresa_id == 1),
        label: "Configurações",
        icon: "mdi mdi-table-settings",
        badgeclass: "badge badge-pill badge-success float-right",
      },
      {
        id: this.getIdCode(),
        url: "/admin/dashboard",
        class: "waves-effect",
        visible: checarPermissao(props.user, "adminDashboard", ["ADMINISTRADOR"]) && (!props.user?.empresa_id || props.user?.empresa_id == 1),
        label: "Dashboard",
        icon: "mdi mdi-chart-line",
        badgeclass: "badge badge-pill badge-success float-right",
      },
    ];
  }

  constructor(props) {
    // console.log("Sidebar constructor: ", props);
    super(props);
    this.state = {
      matchs: "",
      selected: -1,
      pendencias: props.pendencias,
    };

    this.getMenu(props);

    // console.log("Sidebar constructor: ", this.data);
  }

  render() {
    return (
      <>
        <div style={{ top: "70px" }} className="left side-menu">
          <div className="sidebar-inner">
            <PerfectScrollbar>
              <div id="sidebar-menu">
                <ul>
                  {this.data.map((item, i) => {
                    // console.log("Sidebar constructor(Item): ", item);
                    if (item.children && item.visible) {
                      return <MenuItemWithChildren item={item} key={i} />;
                    } else if (item.visible) {
                      if (item.is_main)
                        return (
                          <li className="menu-title" key={i}>
                            {item.label}
                          </li>
                        );
                      else
                        return (
                          <li key={i}>
                            <MenuItem item={item} />
                          </li>
                        );
                    }
                  })}
                </ul>
                {checarPermissao(this.props.user, "adminNilza", ["ADMINISTRADOR", "OPERADOR"]) && <Nilza />}
              </div>
              {/* <Whatsappbtn phone={process.env.REACT_WHATSAPP_FONE || '5562982270001'} /> */}

            </PerfectScrollbar>
          </div>

        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.dados.user,
    proposta: state.dados.proposta,
    pendencias: state.dados.pendencias,
  };
}

export default withRouter(connect(mapStateToProps)(Sidebar));
